/*
 * @Author: Dom
 * @Date: 2022-05-25 16:18:48
 * @LastEditTime: 2022-05-30 17:22:22
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\personal\component\password\store.ts
 */
import { Mutation, Action } from 'vuex';
import { StoreModuleType } from "@/utils/store";
import {updatePassword} from './service';

export interface StateType {
    errorMsg?: string;
    password: string;
    newPassword: string;
    newPassword2: string;
    username: string;
}

export interface ModuleType extends StoreModuleType<StateType>{
    state: StateType;
    mutations: {
        changeErrorMsg: Mutation<StateType>;
    },
    actions: {
        updatePasswordFn: Action<StateType,StateType>
    }
}

const initState: StateType = {
    errorMsg: undefined,
    password: '',
    newPassword: '',
    newPassword2: '',
    username: ''
}

const StoreModel: ModuleType = {
    namespaced: true,
    name: 'updatePassword',
    state: {
        ...initState
    },
    mutations: {
        changeErrorMsg(state, payload) {
            state.errorMsg = payload;
        },
    },
    actions: {
        async updatePasswordFn({ commit },params:StateType){
            let msg: string | undefined = undefined
            try{
                await updatePassword(params)
                msg = '';
            }catch(error:any){
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }

            commit('changeErrorMsg',msg);

            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        }
    }
}

export default StoreModel

